import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse } from '@card-software/nexus-utilities';
import { MaintenanceWorkOrderReason } from '../models/maintenance-work-order/maintenance-work-order-reason';

@Injectable({ providedIn: 'root' })
export class MaintenanceWorkOrderReasonProxyService {
  private readonly httpClient = inject(HttpClient);

  private readonly baseUrl = environment.proxyUrls.ascApi + '/api/v1/maintenance-work-order-reason';

  getAll(): Observable<ApiResponse<MaintenanceWorkOrderReason[]>> {
    return this.httpClient.get<ApiResponse<MaintenanceWorkOrderReason[]>>(`${this.baseUrl}/all`);
  }

  getById(id: string): Observable<ApiResponse<MaintenanceWorkOrderReason>> {
    return this.httpClient.get<ApiResponse<MaintenanceWorkOrderReason>>(`${this.baseUrl}/${id}`);
  }

  create(entity: MaintenanceWorkOrderReason): Observable<ApiResponse<MaintenanceWorkOrderReason>> {
    return this.httpClient.post<ApiResponse<MaintenanceWorkOrderReason>>(this.baseUrl, entity);
  }

  update(id: string, entity: MaintenanceWorkOrderReason): Observable<ApiResponse<MaintenanceWorkOrderReason>> {
    return this.httpClient.put<ApiResponse<MaintenanceWorkOrderReason>>(`${this.baseUrl}/${id}`, entity);
  }

  delete(id: string): Observable<ApiResponse<null>> {
    return this.httpClient.delete<ApiResponse<null>>(`${this.baseUrl}/${id}`);
  }
}
